import { useEffect, useState } from 'react';
import {
  type DesktopUpdateStatus,
  desktopUpdateStatus,
  isElectronDesktop,
  subscribeDesktopUpdateStatus,
} from '@/lib/electron-bridge';

export function useDesktopUpdateStatus(): DesktopUpdateStatus | null {
  const [status, setStatus] = useState<DesktopUpdateStatus | null>(null);

  useEffect(() => {
    if (!isElectronDesktop()) return;
    let cancelled = false;
    let receivedEvent = false;
    const unlisten = subscribeDesktopUpdateStatus((next) => {
      receivedEvent = true;
      if (!cancelled) setStatus(next);
    });
    void desktopUpdateStatus().then(
      (next) => {
        if (!cancelled && !receivedEvent) setStatus(next);
      },
      () => {
        // The native event will recover the view when the main process is ready.
      },
    );
    return () => {
      cancelled = true;
      unlisten();
    };
  }, []);

  return status;
}
